import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Immutable from 'seamless-immutable';
import { QuestionAnswering } from '../../components';


const INITIAL_STATE = {
  questionIndex: 0,
  progress: 0,
  selectedAnswers: Immutable({}),
};

class Test extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (!this.props.test) {
      if (this.props.match.params.testId) {
        this.props.loadTest({ id: this.props.match.params.testId });
      }

      if (this.props.match.params.resultId) {
        this.props.loadResult({ id: this.props.match.params.resultId });
      }
    }
  }

  render() {
    if (!this.props.test) {
      return null;
    }

    return (
      <QuestionAnswering
        questions={this.props.questions}
        completed={this.props.completed}
        onRestart={this.props.onRestart}
        onLoadCard={this.props.onLoadCard}
        onExportContent={this.props.onExportContent}
        onCloseLinkedCard={this.props.onCloseLinkedCard}
        testRun={this.props.testRun}
        onSubmitAnswer={this.props.onSubmitAnswer}
        onSubmitTest={this.props.onSubmitTest}
        test={this.props.test}
        tests={this.props.tests}
        isLoading={this.props.isLoading}
        card={this.props.card}
        location={this.props.location}
        onOpenResults={() => this.props.history.push('/results')}
        onOpenTests={() => this.props.history.push('/tests')}
      />
    );
  }
}

Test.propTypes = {
  questions: PropTypes.array,
  completed: PropTypes.bool,
  onRestart: PropTypes.func,
  onLoadCard: PropTypes.func,
  onCloseLinkedCard: PropTypes.func,
  testRun: PropTypes.object,
  onSubmitAnswer: PropTypes.func,
  onSubmitTest: PropTypes.func,
  test: PropTypes.object,
  tests: PropTypes.array,
  isLoading: PropTypes.bool,
  card: PropTypes.object,
  location: PropTypes.any,
  history: PropTypes.any,
  match: PropTypes.any,
  loadTest: PropTypes.func,
  loadResult: PropTypes.func,
};

Test.defaultProps = {
  testRun: null,
  test: null,
  card: null,
  location: null,
  match: null,
  history: null,
  isLoading: false,
  completed: false,
  tests: [],
  questions: [],
  onRestart: () => { },
  onLoadCard: () => { },
  onCloseLinkedCard: () => { },
  onSubmitAnswer: () => { },
  onSubmitTest: () => { },
  loadTest: () => { },
  loadResult: () => { },
};


export default Test;



// WEBPACK FOOTER //
// ./src/app/main/test/test.js